<template>
  <div class="main">
    <div class="title">
      <div class="name">展示页面</div>
    </div>
    <div class="box">
      <div class="box-title">页面设置</div>
      <div class="form-box">
        <el-form ref="form" :model="ruleForm" label-width="160px">
          <el-form-item label="是否显示系统推荐专家">
            <el-radio-group v-model="ruleForm.tuijian">
              <el-radio label="1" border size="medium" style="width: 110px;">显示</el-radio>
              <el-radio label="0" border size="medium" style="width: 110px;">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否展示机构信息">
            <el-radio-group v-model="ruleForm.jigou">
              <el-radio label="1" border size="medium" style="width: 110px;">显示</el-radio>
              <el-radio label="0" border size="medium" style="width: 110px;">不显示</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="须登录后查看">
            <el-radio-group v-model="ruleForm.look">
              <el-radio label="1" border size="medium" style="width: 110px;">是</el-radio>
              <el-radio label="0" border size="medium" style="width: 110px;">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="须登录后预约">
            <el-radio-group v-model="ruleForm.yuyue" >
              <el-radio label="1" border size="medium" style="width: 110px;">是</el-radio>
              <el-radio label="0" border size="medium" style="width: 110px;">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="setSetting" round style="width: 110px;">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div style="width: 100%;height: 10px;"></div>
    <div class="box">
      <div class="box-title">展示链接</div>
      <div class="flex justify-between align-center">
        <div class="box-href">
          <p>网址 :{{urlStr + url + oid + url2}} </p>
          <div class="flex justify-center margin-top">
            <span @click="copy(urlStr + url + oid + url2)" class="s1">复制</span>
            <span class="s2" @click="to">查看展示页面</span>
          </div>
        </div>
        <div class="box-ewm">
<!--         <vue-qr :text="config.text" :logoScale="40" :size="300" :logoSrc="config.logo">-->
<!--         </vue-qr>-->
<!--          1、:text 用于绑定生成二维码内容-->
<!--          2、:logoScale 中间logo标志大小，单位px-->
<!--          3、:logoSrc 用于绑定二维码中间logo图片的地址-->
<!--          <img src="../../../assets/images/erweima_emof.jpg" alt="">-->
          <vueQr :text="urlStr + url3 + oid" :margin="0" />
          <p>扫一扫 手机查看展示页面</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getSetting, setSetting} from "@/api/index";
import {urlStr} from "@/config";
import vueQr from 'vue-qr'
export default {
  name: "Exhibition",
  data() {
    return {
      urlStr:urlStr,
      id:'',
      url:'/vw/expert?showId=',
      url2:'&register_type=3',
      url3:'/h5/index.html?showId=',
      ruleForm:{
        tuijian: '1',
        jigou: '1',
        look: '1',
        yuyue: '1'
      },
      oid:''
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {
    vueQr
  },
  created() {
    this.$emit("setActive", {
      active: 3,
      act: -1,
      name: '展示页面'
    })
    this.getSetting()
  },
  methods: {
    copy(url) {
        // 模拟 输入框
        var cInput = document.createElement("input");
        cInput.value = url;
        document.body.appendChild(cInput);
        cInput.select(); // 选取文本框内容
        // 执行浏览器复制命令
        // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
        // Input要在正常的编辑状态下原生复制方法才会生效
        document.execCommand("copy");
        this.$message({
          type: "success",
          message: "复制成功"
        });
        // 复制成功后再将构造的标签 移除
        document.body.removeChild(cInput);
    },

    async getSetting() {
      let _res = await getSetting(
          this.user.mid
      );
      if (_res.status === 200) {
        this.ruleForm = {
          tuijian: String(_res.data.setting.is_tui),
          jigou:  String(_res.data.setting.is_org),
          look:  String(_res.data.setting.login_show),
          yuyue:  String(_res.data.setting.login_yuyue)
        }
        this.oid =  _res.data.setting.oid
      } else {
        this.$message.error(_res.msg)
      }
    },
    //
    to(){
      let routerJump = this.$router.resolve({
        path: '/expert',
        query: {
          showId: this.oid,
          register_type:3
        }
      });
      window.open(routerJump.href, '_blank');

      // this.$router.push({
      //   path:'/expert',
      //   query:{
      //     showId: this.oid,
      //     register_type:3
      //   }
      // })
    },

    // 获取列表
    async setSetting() {
      let _res = await setSetting(
          this.user.mid,
          this.ruleForm.tuijian,
          this.ruleForm.jigou,
          this.ruleForm.look,
          this.ruleForm.yuyue
      );
      if (_res.status === 200) {
        this.$message.success(_res.msg)
      } else {
        this.$message.error(_res.msg)
      }
    },

  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
.main {
  display: flex;
  flex-direction: column;
  .title {
    padding: 5px 8px 15px 8px;
    .name {
      font-size: 20px;
      color: #ffffff;
      font-weight: bold;
    }
  }
  .box {
    width: 100%;
    border-radius: 10px;
    padding: 20px;
    background-color: #ffffff;
    flex: 1;
    .form-box {
      padding-top: 20px;
    }
    .btn-box {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-bottom: 30px;
      a {
        width: 201px;
        height: 40px;
        background-color: #0a2240;
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .img-box {
      width: 297px;
      height: 437px;
      background-color: #f3f7fb;
      border-radius: 10px;
      padding: 15px;
      margin: 30px auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .box-ewm {
      width: 300px;
      height: 200px;
      background: #f3f7fb;
      margin-top: 20px;
      border-radius: 12px;
      margin-left: 20px;
      img {
        width: 140px;
        height: 140px;
        display: block !important;
        margin: 10px auto;
        margin-top: 20px;
      }
      p {
        width: 100%;
        text-align: center;
        font-size: 14px;
      }
    }
    .box-href {
      //width: 740px;
      width: 100%;


      //height: 60px;
      background-color: #f3f7fb;
      border-radius: 12px;
      //margin: 40px auto;
      margin-top: 20px;
      padding: 25px;
      p {
        width: 100%;
        height: 80px;
        background-color: #ffffff;
        border-radius: 10px;
        font-size: 14px;
        letter-spacing: 1px;
        color: #333333;
        line-height: 80px;
        padding: 0 20px;
      }
      .s1 {
        width: 79px;
        height: 40px;
        background-color: #0a2240;
        border-radius: 20px;
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
        margin-left: 15px;
      }
      .s2 {
        width: 129px;
        height: 40px;
        background-color: #0a2240;
        border-radius: 20px;
        font-size: 14px;
        text-align: center;
        line-height: 40px;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
        margin-left: 15px;
      }
    }
    .box-title {
      width: 100%;
      font-size: 18px;
      color: #0a2240;
    }
  }

}
</style>


